module.exports = __webpack_public_path__ + "img/Frame-14.7673259d.svg";